module.exports = __webpack_public_path__ + "img/cert3.dc943c17.jpg";